import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const OrderEditView = React.lazy(() => import('@/modules/orderV2/order-edit-view'))
const OrderDetail = React.lazy(() => import('@/modules/order/detail/order-detail'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))
const OrderList = React.lazy(() => import('@/modules/order/list/order-list'))

const orderRoutes = (
  <>
    <Route path='order/*' element={<RedirectToPlural />} />
    <Route path='orders' Component={OrderList} handle={{ title: 'Aufträge', options: { noBackgroundColor: true } }} />
    <Route path='orders/new' Component={OrderEditView} />
    <Route path='orders/edit/:id' Component={OrderEditView} />
    <Route path='orders/new/customer/:customerId' Component={OrderEditView} />
    <Route path='orders/:id' Component={OrderDetail} />
    <Route path='orders/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
  </>
)

export default orderRoutes
